import { Dialog } from 'element-ui'
// 全局组件，按需引入
const element = {
  install: function (Vue) {
    Vue.use(Dialog)
  }
}
export default element


// WEBPACK FOOTER //
// ./src/commonComponents/index.js